import React from 'react';
import { Link } from 'react-router-dom';
import './TermsPage.css';

function TermsPage() {
  return (
    <div className="terms-page">
      <div className="terms-hero">
        <div className="terms-hero-content">
          <h1 className="terms-hero-title">Terms & Conditions</h1>
          <p className="terms-hero-subtitle">
            Please read these terms carefully before booking
          </p>
        </div>
      </div>

      <div className="terms-content">
        <div className="terms-section">
          <h2>Booking and Payment</h2>
          <p>
            All bookings are subject to availability and confirmation. A deposit is required to 
            secure your booking, with the balance due before the start of your tour. Payment 
            methods accepted include credit cards, bank transfers, and other agreed methods.
          </p>
        </div>

        <div className="terms-section">
          <h2>Cancellation Policy</h2>
          <p>Cancellation charges apply as follows:</p>
          <ul>
            <li><strong>More than 60 days before departure:</strong> Deposit forfeited</li>
            <li><strong>30-60 days before departure:</strong> 50% of total cost</li>
            <li><strong>15-29 days before departure:</strong> 75% of total cost</li>
            <li><strong>Less than 15 days before departure:</strong> 100% of total cost</li>
          </ul>
          <p>
            Refunds will be processed within 14 business days of cancellation confirmation.
          </p>
        </div>

        <div className="terms-section">
          <h2>Travel Insurance</h2>
          <p>
            We strongly recommend that all travelers obtain comprehensive travel insurance covering 
            medical expenses, personal accident, trip cancellation, and personal liability. 
            Travel insurance is mandatory for Kilimanjaro climbs and certain adventure activities.
          </p>
        </div>

        <div className="terms-section">
          <h2>Health and Fitness</h2>
          <p>
            Some tours require a reasonable level of fitness and health. It is your responsibility 
            to inform us of any medical conditions, disabilities, or special requirements. We 
            reserve the right to refuse participation if we believe it may pose a risk to your 
            health or safety.
          </p>
        </div>

        <div className="terms-section">
          <h2>Changes to Itinerary</h2>
          <p>
            While we strive to follow the planned itinerary, we reserve the right to make changes 
            due to weather conditions, safety concerns, or other circumstances beyond our control. 
            We will notify you of significant changes as soon as possible.
          </p>
        </div>

        <div className="terms-section">
          <h2>Liability</h2>
          <p>
            Digital Dream Safaris acts as an agent for various service providers. We are not 
            liable for any loss, damage, injury, or death resulting from the acts or omissions of 
            third-party service providers. Participants engage in activities at their own risk.
          </p>
        </div>

        <div className="terms-section">
          <h2>Force Majeure</h2>
          <p>
            We are not liable for failure to perform our obligations due to circumstances beyond 
            our reasonable control, including natural disasters, war, terrorism, or government 
            restrictions.
          </p>
        </div>

        <div className="terms-section">
          <h2>Complaints</h2>
          <p>
            If you have any complaints during your tour, please inform us immediately so we can 
            address the issue. We are committed to resolving any problems promptly and fairly.
          </p>
        </div>

        <div className="terms-footer">
          <p>Last updated: {new Date().getFullYear()}</p>
          <Link to="/" className="btn btn-secondary">Back to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;

